import * as React from "react";
import Input, { InputOwnerState } from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Stack from "@mui/joy/Stack";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { SlotProps } from "@mui/joy/utils/types";
import { Typography, VariantProp } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";

export interface CustomInputProps {
  id?: string;
  label?: string;
  seeLabelInStartDecorator?: boolean;
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  value?: string | number;
  defaultValue?: string | number;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  inputSlotProps?: SlotProps<"input", {}, InputOwnerState>;
  disabled?: boolean;
  inputDisabled?: boolean;
  variant?: VariantProp;
  color?: "danger" | "success" | "warning" | "neutral" | "primary";
  error?: boolean;
  errorHelperText?: string;
  helperText?: string;
  startDecorator?: React.ReactNode;
  endDecorator?: React.ReactNode;
  sx?: SxProps;
}

const CustomInput: React.FC<CustomInputProps> = ({
  id,
  label,
  seeLabelInStartDecorator = true,
  placeholder,
  type,
  value,
  defaultValue,
  onChange,
  onClick,
  inputSlotProps,
  disabled,
  inputDisabled,
  variant,
  color,
  error,
  errorHelperText,
  helperText,
  startDecorator,
  endDecorator,
  sx,
}) => {
  if (inputDisabled) {
    return (
      <Stack spacing={2}>
        {/* Decoradores */}
        <Stack direction="row" justifyContent="space-between">
          {(startDecorator && startDecorator) ||
            (seeLabelInStartDecorator && label && (
              <Typography variant="plain" color="neutral">
                {label}:
              </Typography>
            ))}
          <FormControl error={error}>
            {!seeLabelInStartDecorator && label && <FormLabel>{label}</FormLabel>}
            <Input
              id={id}
              placeholder={placeholder}
              defaultValue={defaultValue}
              value={value}
              onChange={onChange}
              onClick={onClick}
              type={type}
              slotProps={{
                input: inputSlotProps,
              }}
              disabled={inputDisabled} // Usar inputDisabled para controlar la deshabilitación de la entrada
              variant={variant}
              color={color}
              sx={sx}
            />

            {(helperText || (error && errorHelperText)) && (
              <FormHelperText>
                <Typography level="body-xs" color={error ? "danger" : "neutral"} paddingInline={1}>
                  {error ? errorHelperText : helperText}{" "}
                </Typography>
              </FormHelperText>
            )}
          </FormControl>
          {endDecorator && endDecorator}
        </Stack>
      </Stack>
    );
  } else {
    return (
      <Stack spacing={2}>
        <FormControl error={error}>
          {!seeLabelInStartDecorator && label && <FormLabel>{label}</FormLabel>}
          <Input
            id={id}
            placeholder={placeholder}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            onClick={onClick}
            type={type}
            slotProps={{
              input: inputSlotProps,
            }}
            disabled={disabled}
            //@ts-ignore
            variant={variant}
            color={color}
            startDecorator={
              (startDecorator && startDecorator) ||
              (seeLabelInStartDecorator && label && (
                <Typography variant="plain" color="neutral">
                  {label}:
                </Typography>
              ))
            }
            endDecorator={endDecorator}
          />

          {(helperText || (error && errorHelperText)) && (
            <FormHelperText>
              <Typography level="body-xs" color={error ? "danger" : "neutral"} paddingInline={1}>
                {error ? errorHelperText : helperText}{" "}
              </Typography>
            </FormHelperText>
          )}
        </FormControl>
      </Stack>
    );
  }
};

export default CustomInput;
